import React, { useCallback } from 'react';
import dayjs from 'dayjs';
import { BasicItem } from '../FormItem';
import PickerView from './PickerView';
import Right from './images/right@2x.png';
import styles from './Picker.module.scss';

// todo 待实现其他
enum Mode {
  date = 'date', // 日期
  // time = 'time', // time
  // datetime = 'datetime', // 日期+时间
  // year = 'year', // 年
  // month = 'month', // 月
}

interface Props {
  mode?: Mode;
  label: string;
  placeholder?: string;
  value: Date | undefined;
  defaultValue?: Date | undefined;
  onChange: (date: Date) => void;
  formate?: (date: Date) => string;
  maxDate?: Date;
  minDate?: Date;
}

export default function DatePicker(props: Props) {
  const {
    mode = 'date',
    minDate = new Date('2000-01-01'),
    maxDate = new Date(), // 最大限制到今日，需要未来请传递maxDate
    label,
    placeholder = '请选择',
    value,
    defaultValue,
    onChange,
    formate,
  } = props;

  const handleChange = useCallback(
    function (valueList: Array<string | number>) {
      onChange(
        new Date(
          valueList
            .map((key, index) => {
              // 兼容ios下 不识别new Date(2020-1-1)
              if (!index) {
                return key;
              } else {
                return ('0' + key).slice(-2);
              }
            })
            .join('-')
        )
      );
    },
    [onChange]
  );

  const getYearChildren = useCallback(
    function (year: number, maxYear: number) {
      const monthList = [];
      const maxMonth = year === maxYear ? maxDate.getMonth() + 1 : 12;

      for (let i = 1; i <= maxMonth; i++) {
        const dayList = [];
        const maxDay =
          year === maxYear ? maxDate.getDate() : new Date(year, i, 0).getDate();

        for (let j = 1; j <= maxDay; j++) {
          dayList.push({ label: j, value: j });
        }
        monthList.push({ label: i, value: i, children: dayList });
      }

      return monthList;
    },
    [maxDate]
  );

  const getData = useCallback(
    function () {
      if (mode === Mode.date) {
        const list = [];

        for (let i = minDate.getFullYear(); i <= maxDate.getFullYear(); i++) {
          list.push({
            label: i,
            value: i,
            children: getYearChildren(i, maxDate.getFullYear()),
          });
        }

        return list;
      }

      return [];
    },
    [getYearChildren, maxDate, minDate, mode]
  );

  const getValue = useCallback(
    function () {
      if (mode === Mode.date) {
        const date = value || defaultValue;

        if (date) {
          return [date.getFullYear(), date.getMonth() + 1, date.getDate()];
        } else {
          return [undefined, undefined, undefined];
        }
      }

      return [];
    },
    [defaultValue, mode, value]
  );

  const formateValue = useCallback(
    function () {
      if (formate) {
        return formate(value!);
      } else {
        return dayjs(value).format('YYYY-MM-DD');
      }
    },
    [formate, value]
  );

  return (
    <BasicItem label={label}>
      <PickerView
        data={getData()}
        value={getValue()}
        cascade
        cols={3}
        onChange={handleChange}
      >
        <div className={styles.content}>
          <p>{value ? formateValue() : <span>{placeholder}</span>}</p>
          <img src={Right} />
        </div>
      </PickerView>
    </BasicItem>
  );
}
